import { AxiosResponse } from 'axios'
import { RequestREAD } from 'services/Instances'
export const ReportCurrentContractService = () => {
  const path = 'RelatorioContratoVigente/Filtro'
  const getFillCards = async (requestObj: Fillcards): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/Fillcards`, requestObj)

  const visualizar = async (requestObj: number[]): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/Visualizar`, requestObj)

  const visualizarExcel = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/Visualizar/Excel`, requestObj)

  return { getFillCards, visualizar, visualizarExcel }
}
export interface Fillcards {
  dataVigencia: Date
  matriculaContraparte: string
  nomeContraparte: string
  matriculaSubstituto: string
  nomeSubstituto: string
  nomeEmpresa: string
  nomeCentro: string
  nomeSubcontratada: string
  nomeFornecedor: string
  unidadeGestoraId: number
  flSocio: boolean
  flRecorrente: boolean
  contrapartesIds: number[]
  substitutosIds: number[]
  empresasIds: number[]
  centrosIds: number[]
  fornecedoresIds: number[]
  subcontratadasIds: number[]
  tiposCreIds: number[]
}
